import React from 'react';
import { css, StyleSheet } from 'aphrodite';

export default class TeamMember extends React.Component {
  render() {
    return (
      <div
        onClick={this.props.selectTeamMember}
        className={`${css(styles.teamMember)}`}>
        <div
          className={`${css(styles.initials)} ${
            this.props.selected ? 'cps-bg-color-primary' : 'cps-bg-gray-9'
            }`}>
          {this.props.initials}
        </div>
        <div
          style={{
            background: '#F2F2F2',
            border: this.props.selected ? '1px solid' : 'none',
          }}
          className={`${css(styles.name)} ${
            this.props.selected ? 'cps-color-primary' : 'cps-gray-10'
            }`}>
          <span className={'cps-ellipsis'}>{this.props.name}</span>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  teamMember: {
    display: 'inline-flex',
    marginBottom: '16px',
    cursor: 'pointer',
    minHeight: '37px',
  },
  initials: {
    padding: '8px',
    color: 'white',
    fontSize: '18px',
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
    fontWeight: 'bold',
  },
  name: {
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
    fontWeight: 'bold',
    maxWidth: '260px',
  },
});
